import { apiInterfaceForJson } from "../common/apiManager";

// AI Agents management (admin only)
export const fetchAiAgents = () => {
    return apiInterfaceForJson("/ai-agent/v1/agents", "GET");
};

export const fetchAiAgentDetail = (agentId) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}`, "GET");
};

export const fetchRetellVoices = () => {
    return apiInterfaceForJson("/ai-agent/v1/voices", "GET");
};

export const updateAiAgent = (agentId, payload) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}`, "PUT", payload);
};

// Version history
export const fetchAgentVersions = (agentId) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/versions`, "GET");
};

export const rollbackAgentVersion = (agentId, versionId) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/versions/${versionId}/rollback`, "POST");
};

// Test calls + analysis loop
export const fetchAgentTestCalls = (agentId) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/test-calls`, "GET");
};

export const startAgentTestCall = (agentId, toNumber, fromNumber, dynamicVariables, customerEmail) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/test-calls`, "POST", { toNumber, fromNumber, dynamicVariables, customerEmail });
};

export const stopAgentTestCall = (id) => {
    return apiInterfaceForJson(`/ai-agent/v1/test-calls/${id}/stop`, "POST");
};

// AI generation can take minutes for large prompts — use a 5 minute timeout
const AI_TIMEOUT = 300000;

export const analyzeAgentTestCall = (id) => {
    return apiInterfaceForJson(`/ai-agent/v1/test-calls/${id}/analyze`, "POST", undefined, undefined, AI_TIMEOUT);
};

export const generateAgentFix = (id, findingIndexes) => {
    return apiInterfaceForJson(`/ai-agent/v1/test-calls/${id}/fix`, "POST", { findingIndexes }, undefined, AI_TIMEOUT);
};

// Claude prompt-editing chat
export const chatWithAgentEditor = (agentId, messages) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/chat`, "POST", { messages }, undefined, AI_TIMEOUT);
};

// Send review notes on a proposal back to Claude for revision
export const reviseAgentProposal = (agentId, payload) => {
    return apiInterfaceForJson(`/ai-agent/v1/agents/${agentId}/revise-proposal`, "POST", payload, undefined, AI_TIMEOUT);
};
